import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { dailyContestArticles } from '@/mocks/home';

export default function DailyContestSection() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (!scrollRef.current) return;
    const scrollAmount = 340;
    scrollRef.current.scrollBy({
      left: direction === 'left' ? -scrollAmount : scrollAmount,
      behavior: 'smooth',
    });
  };

  return (
    <section className="py-14 md:py-18 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <div className="flex items-center gap-3 mb-2">
              <span className="px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold">
                实时更新
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                每日<span className="text-primary-500">大赛</span>
              </h2>
            </div>
            <p className="text-sm text-foreground-500 mt-1">网红塌房黑料不断更，每日最新爆料汇总</p>
          </div>

          <div className="hidden md:flex items-center gap-2">
            <button
              onClick={() => scroll('left')}
              className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50 text-foreground-600 hover:bg-primary-50 hover:text-primary-500 transition-colors cursor-pointer"
              aria-label="向左滚动"
            >
              <i className="ri-arrow-left-s-line" />
            </button>
            <button
              onClick={() => scroll('right')}
              className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50 text-foreground-600 hover:bg-primary-50 hover:text-primary-500 transition-colors cursor-pointer"
              aria-label="向右滚动"
            >
              <i className="ri-arrow-right-s-line" />
            </button>
          </div>
        </div>

        <div
          ref={scrollRef}
          className="flex gap-4 overflow-x-auto pb-2 -mx-1 px-1"
          style={{ scrollSnapType: 'x mandatory' }}
        >
          {dailyContestArticles.map((article, idx) => (
            <Link
              key={article.id}
              to="/category/all"
              className="flex-shrink-0 w-[280px] md:w-[320px] bg-background-50 rounded-xl overflow-hidden group cursor-pointer"
              style={{ scrollSnapAlign: 'start' }}
            >
              <div className="relative w-full aspect-square overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading={idx < 4 ? 'eager' : 'lazy'}
                  title={`${article.title} - 吃瓜网站每日大赛`}
                />
                <span className="absolute top-3 left-3 px-2 py-1 rounded-md bg-background-950/70 text-background-50 text-[11px] font-medium">
                  {article.category}
                </span>
              </div>

              <div className="p-4">
                <h3 className="font-heading text-base font-semibold text-foreground-900 line-clamp-2 leading-snug mb-2 group-hover:text-primary-500 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-1 mb-3">
                  {article.description}
                </p>
                <div className="flex items-center gap-2 text-xs text-foreground-400">
                  <i className="ri-eye-line" />
                  <span>{article.views}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}